import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createHousehold, findHouseholdByCode } from "../api/households";
import { joinHousehold } from "../api/households";
import { setDoc, doc } from "firebase/firestore";
import { db, auth } from "../firebase";

export default function SetupHouseholdPage() {

    const navigate = useNavigate();

    const [mode, setMode] = useState(null);
    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [found, setFound] = useState(null);
    const [error, setError] = useState("");

    function goBack() {
        setMode(null);
    }

    async function handleCreate() {

  try {

    // 1️⃣ Create household
    const result = await createHousehold(name, auth.currentUser.uid);

    // 2️⃣ Create/update user document
    const userRef = doc(db, "users", auth.currentUser.uid);
    await setDoc(userRef, {
      name: auth.currentUser.displayName,
      email: auth.currentUser.email,
      householdId: result.id
    }, { merge: true }); // merge ensures existing fields aren't overwritten

    alert(`Household created! Share code: ${result.code}`);

    navigate("/");

  } catch (err) {
    console.error("Create Household Error:", err);
    alert("Failed to create household. Try again.");
  }

}

    async function handleSearch() {

        const result = await findHouseholdByCode(code);

        if (!result) {
            setError("Household not found");
            return;
        }

        setFound(result);

    }

    async function handleConfirmJoin() {
        if (!found) return;

        try {
            // 1. Add user to household members
            await joinHousehold(found.id, auth.currentUser.uid);

            // 2. Update user's householdId
            const userRef = doc(db, "users", auth.currentUser.uid);
            await setDoc(userRef, {
                householdId: found.id,
                name: auth.currentUser.displayName,
                email: auth.currentUser.email
            }, { merge: true });

            alert(`You joined the ${found.name} household!`);

            // 3. Navigate to dashboard
            navigate("/");

        } catch (err) {
            console.error(err);
            setError("Failed to join household. Try again.");
        }
    }

    return (

        <div className="setupPage">

            <h1>Finish Setting Up Your Account</h1>

            {!mode && (

                <div className="setupOptions">

                    <button onClick={() => setMode("create")}>
                        Create Household
                    </button>

                    <button onClick={() => setMode("join")}>
                        Join Household
                    </button>

                </div>

            )}

            {mode === "create" && (

                <div className="setupCard">

                    <button
                        className="backButton"
                        onClick={goBack}
                    >
                        ← Back
                    </button>

                    <h2>Create Household</h2>

                    <input
                        placeholder="Household Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />

                    <button onClick={handleCreate}>
                        Create Household
                    </button>

                </div>

            )}

            {mode === "join" && (

                <div className="setupCard">

                    <button
                        className="backButton"
                        onClick={goBack}
                    >
                        ← Back
                    </button>

                    <h2>Join Household</h2>

                    <input
                        placeholder="Enter Household Code"
                        value={code}
                        onChange={e => setCode(e.target.value)}
                    />

                    <button onClick={handleSearch}>
                        Find Household
                    </button>

                    {error && <p className="error">{error}</p>}

                    {found && (

                        <div className="confirmJoin">

                            <p>
                                Join <b>{found.name}</b> household?
                            </p>

                            <button onClick={handleConfirmJoin}>
                                Confirm
                            </button>

                        </div>

                    )}

                </div>

            )}
        </div>

    )

}